import SmoothScroll from 'smooth-scroll';
import '@fancyapps/fancybox';

var navTimeouts = [];
var $html = $( 'html' );

var smoothScroll = new SmoothScroll( 'a[href*="#"]', {
	topOnEmptyHash: false,
	updateURL: false,
	speed: 2000,
	speedAsDuration: true,
	offset: function( anchor, toggle ) {
		return 0;
	},
} );

$( function() {
	sanitizeTargetBlank();

	$( '.fancybox' ).fancybox( {} );

	$( '.hamburger-container' ).on( 'click', function( event ) {
		var $this = $( this );

		if ( $html.hasClass( 'active-main-menu' ) ) {
			closeHamburger();
		} else {
			openHamburger();
		}
	} );

	$( '.close-hamburger' ).on( 'click', function( event ) {
		closeHamburger();
	} );
} );

var newScrollTop,
	currentScrollTop = 0,
	scrollTarget = $( 'html' );

$( window ).scroll( function() {
	var scrollTop = $( window ).scrollTop();

	if ( scrollTop > 20 ) {
		scrollTarget.addClass( 'scrolling' );

		currentScrollTop = scrollTop;

		if ( newScrollTop < currentScrollTop ) {
			scrollTarget.addClass( 'scroll-down' ).removeClass( 'scroll-up' );
		} else if ( newScrollTop > currentScrollTop ) {
			scrollTarget.removeClass( 'scroll-down' ).addClass( 'scroll-up' );
		}
		newScrollTop = currentScrollTop;
	} else {
		scrollTarget.removeClass( 'scroll-down' ).removeClass( 'scrolling' ).removeClass( 'scroll-up' );
	}
} );

function openHamburger() {
	$html.addClass( 'active-main-menu' );

	$( '.hamburger-container' ).addClass( 'active' );

	$( '.mobile-site-navigation' ).addClass( '!pointer-events-auto !opacity-100' );

	$( '.mobile-site-navigation a' ).each( function( index ) {
		var $this = $( this );

		navTimeouts.push( setTimeout( function() {
			$this.addClass( 'active' );
		}, 100 + index * 33 ) );
	} );
}

export function closeHamburger() {
	$( '.hamburger-container' ).removeClass( 'active' );

	$( '.mobile-site-navigation' ).removeClass( '!pointer-events-auto !opacity-100' );

	$( '.mobile-site-navigation a' ).removeClass( 'active' );

	navTimeouts.forEach( function( timeout ) {
		clearTimeout( timeout );
	} );

	navTimeouts = [];

	$html.removeClass( 'active-main-menu' );
}

/* 3/24/2017 Sanitize_Target_Blank.htm https://gist.github.com/JamoCA/80f65eb07f054b1326221bd4f15868d6 */
function sanitizeTargetBlank() {
	$( 'a[rel~=external]' ).prop( 'target', '_blank' );
	$( 'a[target="_blank"]' ).each( function() {
		var a = $( this );
		if ( location.hostname !== this.hostname ) {
			var originalRel = (this.rel === undefined) ? '' : this.rel.toLowerCase();
			var newRel = originalRel.split( " " );
			if ( originalRel.indexOf( 'noopener' ) === -1 ) {
				newRel.push( 'noopener' );
			}
			if ( originalRel.indexOf( 'noreferrer' ) === -1 ) {
				newRel.push( 'noreferrer' );
			}
			if ( originalRel.indexOf( 'nofollow' ) === -1 ) {
				newRel.push( 'nofollow' );
			}
			a.attr( 'rel', newRel.join( " " ).trim() );
		}
	} );
	console.log( 'External AHREF links have been sanitized.', new Date );
}

function viewRel() {
	var linkLog = [];
	console.log( 'Identifying all AHREF links with target="_blank"...' );
	$( 'a[target="_blank"]' ).each( function( i ) {
		var a = $( this );
		var r = a.attr( 'rel' );
		if ( r !== undefined ) {
			r = r.split( " " );
		}
		var entry = {
			'index': i,
			'linkText': a.text(),
			'href': a.attr( 'href' ),
			'target': a.attr( 'target' ),
			'rel': r,
		};
		linkLog.push( entry );
	} );
	console.table( linkLog );
}
